var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"#fff"}},[_c('quill-editor',{attrs:{"options":_vm.editorOption},model:{value:(_vm.quill_value),callback:function ($$v) {_vm.quill_value=$$v},expression:"quill_value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }